import { Box, TextField, Typography } from '@mui/material';

const CustomTextBox = ({
    label,
    onChange,
    value,
    error,
    helperText,
    InputProps,
    rows,
    maxLength,
    className = '',
}) => {
    const isMultiline = rows > 1;

    return (
        <Box className="flex flex-col w-full mt-3">
            <Typography
                variant={'body14'}
                className={`${error ? 'text-red-500' : 'text-gray-500'} mb-1 ${className}`}
            >
                {label}
            </Typography>
            <TextField
                variant="outlined"
                size="small"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className={className}
                error={!!error}
                helperText={error && helperText ? helperText : ''}
                FormHelperTextProps={{
                    className: 'text-red-500 !ml-0 !mt-1',
                }}
                InputProps={{
                    ...InputProps,
                    inputProps: {
                        ...InputProps?.inputProps,
                        maxLength,
                    },
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                    },
                    ...(!isMultiline && {
                        '& .MuiOutlinedInput-input': {
                            height: 20,
                            padding: '10px 12px',
                        },
                    }),
                }}
                multiline={isMultiline}
                rows={rows || 1}
            />
        </Box>
    );
};

export default CustomTextBox;
